import React, { Component } from 'react';
import {Button} from 'reactstrap';
import UploadDataLandingPlaceholder from './../../../assets/placeholders/upload_data_landing_placeholder.svg';

class UploadDataLanding extends Component {
  state = {  }
  render() { 
    return ( 
      <div>
        <div className="mt30 mb20">
          <div className="title-text" style={{fontWeight:'bolder'}}>
            Upload Data
          </div>
          <hr />
          <div className="text-center">
            <img className="mt40" style={{height:'150px'}} src={UploadDataLandingPlaceholder}/>
            <div className="import-data-subheader mt20">
              To enable creation of charts in the Analytics module, you need to upload a .csv file with your 
              data, or link with your Human Capital Management system.  You can also do this later.
            </div>
            <div className="row mb10 mt40">
              <div className="col">
                <div className="row justify-content-center">
                  <div className="col-md-3 col-lg-3">
                    <Button color="primary" 
                    style={{width:'100%',fontWeight:'bolder'}}
                    onClick={() => {this.props.history.push('upload-data-category')}}
                    className="continueBtn">
                      Upload Data
                    </Button>                
                  </div>
                  <div className="col-md-3 col-lg-3">
                    <Button color={'secondary-filled'} onClick={() => {this.props.history.push('/home')}} className="goBackBtn">
                      <span>I'll Do It Later</span>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
 
export default UploadDataLanding;